import { Component, OnInit } from '@angular/core';
import {DatasetStatus, DeploymentsService} from "../deployments.service";
import {DataService} from "../data.service";
import {ActivatedRoute} from "@angular/router";
import {ErddapService} from "../erddap.service";
import {log} from "util";

@Component({
  selector: 'app-dev-data-status',
  templateUrl: './dev-data-status.component.html',
})
export class DevDataStatusComponent implements OnInit {

    datasetStatus: DatasetStatus[] = [];
    missions: any[];
    erddapMetadata: any;
    deploymentNumber: number | null;
    selectedDataFormat = '.nc';
    selectedMetadataFormat = '.nc';
    selectedDatasetType: 'Delayed' | 'Realtime';
    ctdVariables = ['time', 'depth', 'latitude', 'longitude', 'conductivity', 'temperature', 'salinity', 'density', 'pressure', 'profile_id'];
    dataUrl: string;
    metadataUrl: string;
    length: number;
    exceptionReason: any[] =[];

    selectedMetadata: {

        delayed: {
            id: string,
            variables: string[] }
            | null,

        realtime: {
            id: string,
            variables: string[] }
            | null
    };

    constructor(
        private deploymentsService: DeploymentsService,
        private erddapService: ErddapService) {
    }

    ngOnInit() {
        this.deploymentsService.getAllDeployments().then(response => {
            this.missions = response.sort((a, b) => b.deployment_number - a.deployment_number);
            this.deploymentsService.getMetadata().then(response => {
                this.erddapMetadata = response;
                    this.deploymentsService.getErddapExceptionReason().then((response: Array<any>) => {
                    this.exceptionReason = response;
                    this.generateDatasetTable();
                });
            });
        });
    }

    generateDatasetTable(){

        let dataUrlRealtime: any;
        let dataUrlDelayed: any;
        let datasetIdRealtime: any;
        let datasetIdDelayed: any;
        let tempStatus: number;
        let delayedExceptionReason: any;
        let realtimeExceptionReason: any;

        for (let i=0; i<this.missions.length; i++){

            if(this.erddapMetadata[this.missions[i].deployment_number].delayed === null || this.erddapMetadata[this.missions[i].deployment_number].realtime === null ){
                tempStatus = 0;
                dataUrlDelayed = "";
                dataUrlRealtime = "";
                delayedExceptionReason = this.exceptionReason[i];
                realtimeExceptionReason = this.exceptionReason[i];
            }
            else {
                realtimeExceptionReason = "";
                delayedExceptionReason = "";
                let selectedErddapMetadata = this.erddapMetadata[this.missions[i].deployment_number];
                datasetIdDelayed = selectedErddapMetadata.delayed.id;
                dataUrlDelayed = this.erddapService.generateDataUrl(datasetIdDelayed, this.ctdVariables, this.selectedDataFormat);
                datasetIdRealtime = selectedErddapMetadata.realtime.id;
                dataUrlRealtime = this.erddapService.generateDataUrl(datasetIdRealtime, this.ctdVariables, this.selectedDataFormat);
                tempStatus = 1;
            }

            var tempDatasetStatus: DatasetStatus = {
                mission: this.missions[i].deployment_number,
                gliderType: this.missions[i].glider_type,
                start_date: this.missions[i].start_time,
                end_date: this.missions[i].end_time,
                status: tempStatus,
                erddapDelayedDatasetURL: dataUrlDelayed,
                erddapRealtimeDatasetURL: dataUrlRealtime,
                erddapRealtimeDatasetReason: realtimeExceptionReason,
                erddapDelayedDatasetReason: delayedExceptionReason,
            }

            this.datasetStatus.push(tempDatasetStatus);
        }
    }
}
